import { FleetTireAddRow } from "services/api/fleet/tires/types";

import { TireSetStepText } from "./types";

export const TIRE_SET_TIRES_STEP = 0;
export const TIRE_SET_WAREHOUSE_STEP = 1;
export const TIRE_SET_DOCUMENTS_STEP = 2;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const TIRE_SET_INTRO_TEXTS: Record<number, TireSetStepText> = {
  [TIRE_SET_TIRES_STEP]: {
    title: "Složite set guma",
    description: "Dodajte gume koje čine set: dimenzija, proizvođač, DOT i dubina profila. Sustav prati svaki set.",
  },
  [TIRE_SET_WAREHOUSE_STEP]: {
    title: "Gdje se set čuva?",
    description: "Odaberite skladište. Tako se uvijek zna gdje su gume kad dođe vrijeme za zamjenu.",
  },
  [TIRE_SET_DOCUMENTS_STEP]: {
    title: "Priložite dokumentaciju",
    description: "Primka, račun dobavljača ili fotografije profila. Sve ostaje uz set na jednom mjestu.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const TIRE_SET_INTRO_SAMPLE = {
  code: "SET 0042",
  manufacturer: "Michelin",
  dimension: "205/55 R16",
  type: "Zimske",
  quantity: 4,
  profileDepths: [7.2, 7.0, 6.8, 6.9],
  dot: 2324,
  warehouseName: "Skladište Jankomir",
  warehouseAddress: "Jankomir 25, Zagreb",
  image: "/media/images/vehicles/tires.webp",
  documents: ["Primka guma.pdf", "Račun dobavljača.pdf", "Fotografije profila.pdf"],
};

/** Dimenzija gume kao "205/55 R16"; dok nije upisana, nema je. */
export const formatTireDimension = (tire: FleetTireAddRow | undefined) =>
  tire?.width && tire?.height && tire?.radius ? `${tire.width}/${tire.height} R${tire.radius}` : null;

/** Ukupan broj guma u setu, zbroj količina po redovima. */
export const countTires = (tires: FleetTireAddRow[]) =>
  tires.reduce((total, tire) => total + (tire.quantity ?? 0), 0);
